import { useMutation } from "@tanstack/react-query";
import { postInviteIndiviual } from "../actions/postInviteIndividual";

export const useInviteIndividual = () => {
  const token = sessionStorage.getItem("token");

  const workforceMutation = useMutation({
    mutationFn: (data) => postInviteIndiviual(data, token),
  });

  return {
    // Mutation
    workforceMutation,
  };
};
